import React from 'react';

import { connect } from '../../../base/redux/index.js';
import Etherpad from '../../../etherpad/components/web/Etherpad.js';
import { GenericIFrame } from '../index.web.js';

/** .
 * Implements a React {@link Component} which represents the GenericIframe (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
function GenericIFrameManager(props: any) {

    return props.whiteBoardVisible ? <GenericIFrame /> : props.etherPadVisible ? <Etherpad /> : null;
}

/**
 * Maps (parts of) the Redux state to the associated GenericIFrameManager props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state: any) {
    const whiteBoardVisible = state['features/genericiframe'].visible;

    const etherPadVisible = state['features/etherpad'].editing;

    return {
        whiteBoardVisible,
        etherPadVisible
    };
}

export default connect(mapStateToProps)(GenericIFrameManager);
